import { getTvObject, tv } from '@costar-ui/cosmos';

var toastTV = getTvObject({
  base: ['bg-base', 'p-4', 'border', 'border-neutral', 'shadow-elevation-20', 'gap-2', 'min-h-14', 'w-full'],
  variants: {
    variant: {
      neutral: 'border-neutral',
      negative: 'border-status-negative',
      caution: 'border-status-caution',
      informative: 'border-status-informative'
    }
  }
});
var base = tv(toastTV);
var toastStyles = {
  base: base
};

export { toastStyles, toastTV };
//# sourceMappingURL=toast.styles.esm.js.map
